
(function () {
  'use strict';

  var wrapper = document.querySelector('[data-z9-collection-grid]');
  if (!wrapper) return;

  var SECTION_ID = wrapper.dataset.sectionId;
  var priceTimer = null;
  var currentCols = 3;

  bindWrapper();
  window.addEventListener('popstate', function () { fetchSection(window.location.href); });

  
  function bindWrapper() {
    wrapper.addEventListener('click', function (e) {
      var t;

      if ((t = e.target.closest('.z9-cg__filter-toggle'))) { toggleGroup(t); return; }
      if ((t = e.target.closest('.z9-cg__active-tag'))) {
        e.preventDefault();
        if (t.dataset.clearPrice !== undefined) {
          clearPrice(); onFilterChange();
        } else {
          var cb = wrapper.querySelector('.z9-cg__filter-input[name="' + t.dataset.param + '"][value="' + t.dataset.value + '"]');
          if (cb) cb.checked = false;
          onFilterChange();
        }
        return;
      }
      if ((t = e.target.closest('.z9-cg__filter-clear'))) { e.preventDefault(); fetchSection(t.href || t.dataset.url); return; }
      if ((t = e.target.closest('.z9-cg__price-preset'))) { applyPreset(t); return; }
      if ((t = e.target.closest('.z9-cg__grid-toggle-btn'))) { setColumns(parseInt(t.dataset.cols, 10)); return; }
      if (e.target.closest('.z9-cg__filter-btn-mobile')) { toggleSidebar(true); return; }
      if (e.target.closest('.z9-cg__sidebar-overlay')) { toggleSidebar(false); return; }
      if (e.target.closest('.z9-cg__sidebar-close')) { toggleSidebar(false); return; }
      if (e.target.closest('.z9-cg__filter-results')) { toggleSidebar(false); return; }
      if (e.target.closest('.z9-cg__filter-footer-clear')) { e.preventDefault(); var c = e.target.closest('.z9-cg__filter-footer-clear'); fetchSection(c.href || c.dataset.url); return; }
      if ((t = e.target.closest('.z9-pc__add-btn'))) { e.preventDefault(); addFromCard(t); return; }
      if ((t = e.target.closest('.z9-cg__load-btn'))) { loadMore(t); return; }
    });

    wrapper.addEventListener('change', function (e) {
      if (e.target.closest('.z9-cg__filter-input')) { onFilterChange(); return; }
      if (e.target.closest('.z9-cg__sort-select')) { onFilterChange(); return; }
    });

    wrapper.addEventListener('input', function (e) {
      if (e.target.closest('.z9-cg__price-field')) {
        clearTimeout(priceTimer);
        priceTimer = setTimeout(onFilterChange, 800);
      }
    });
  }

  
  function onFilterChange() {
    fetchSection(buildFilterUrl());
  }

  function buildFilterUrl() {
    var params = [];
    var boxes = wrapper.querySelectorAll('.z9-cg__filter-input:checked');
    for (var i = 0; i < boxes.length; i++) {
      params.push(enc(boxes[i].name) + '=' + enc(boxes[i].value));
    }
    var minEl = wrapper.querySelector('.z9-cg__price-field[data-type="min"]');
    var maxEl = wrapper.querySelector('.z9-cg__price-field[data-type="max"]');
    if (minEl && minEl.value !== '') params.push(enc(minEl.name) + '=' + enc(minEl.value));
    if (maxEl && maxEl.value !== '') params.push(enc(maxEl.name) + '=' + enc(maxEl.value));
    var sortEl = wrapper.querySelector('.z9-cg__sort-select');
    if (sortEl && sortEl.value) params.push('sort_by=' + enc(sortEl.value));
    return window.location.pathname + (params.length ? '?' + params.join('&') : '');
  }

  function clearPrice() {
    var a = wrapper.querySelector('.z9-cg__price-field[data-type="min"]');
    var b = wrapper.querySelector('.z9-cg__price-field[data-type="max"]');
    if (a) a.value = '';
    if (b) b.value = '';
  }

  function applyPreset(btn) {
    var minEl = wrapper.querySelector('.z9-cg__price-field[data-type="min"]');
    var maxEl = wrapper.querySelector('.z9-cg__price-field[data-type="max"]');
    if (minEl) minEl.value = btn.dataset.min || '';
    if (maxEl) maxEl.value = btn.dataset.max || '';
    onFilterChange();
  }

  
  function fetchSection(url) {
    var sep = url.indexOf('?') > -1 ? '&' : '?';
    var fetchUrl = url + sep + 'section_id=' + SECTION_ID;

    wrapper.classList.add('z9-cg--loading');

    fetch(fetchUrl)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nw = doc.querySelector('[data-z9-collection-grid]');
        if (nw) wrapper.innerHTML = nw.innerHTML;
        wrapper.classList.remove('z9-cg--loading');

        parseSplitData();

        var grid = wrapper.querySelector('.z9-cg__grid');
        if (grid) grid.dataset.columns = currentCols;
        var activeBtn = wrapper.querySelector('.z9-cg__grid-toggle-btn[data-cols="' + currentCols + '"]');
        if (activeBtn) {
          var all = wrapper.querySelectorAll('.z9-cg__grid-toggle-btn');
          for (var i = 0; i < all.length; i++) all[i].classList.remove('is-active');
          activeBtn.classList.add('is-active');
        }

        if (window.jdgm && typeof jdgm.customizeBadges === 'function') jdgm.customizeBadges();

        var tb = wrapper.querySelector('.z9-cg__toolbar');
        if (tb) tb.scrollIntoView({ behavior: 'smooth', block: 'start' });
      })
      .catch(function () { wrapper.classList.remove('z9-cg--loading'); });

    var clean = url.replace(/[?&]section_id=[^&]*/, '');
    window.history.pushState({}, '', clean || url);
  }

  
  function loadMore(btn) {
    var container = wrapper.querySelector('.z9-cg__load-more');
    if (!container) return;
    var nextUrl = container.dataset.nextUrl;
    if (!nextUrl) return;

    btn.disabled = true;
    var origHTML = btn.innerHTML;
    btn.textContent = 'LOADING...';

    var sep = nextUrl.indexOf('?') > -1 ? '&' : '?';
    fetch(nextUrl + sep + 'section_id=' + SECTION_ID)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.querySelector('.z9-cg__grid');
        var currentGrid = wrapper.querySelector('.z9-cg__grid');

        if (newGrid && currentGrid) {
          var cards = newGrid.querySelectorAll('.z9-pc');
          for (var i = 0; i < cards.length; i++) {
            currentGrid.appendChild(cards[i].cloneNode(true));
          }
        }

        var newLM = doc.querySelector('.z9-cg__load-more');
        container.dataset.nextUrl = newLM ? (newLM.dataset.nextUrl || '') : '';

        var total = parseInt(container.dataset.total, 10) || 1;
        var shown = currentGrid ? currentGrid.querySelectorAll('.z9-pc').length : 0;

        var bar = container.querySelector('.z9-cg__progress-bar');
        if (bar) bar.style.width = Math.min(shown / total * 100, 100) + '%';

        var countEl = container.querySelector('.z9-cg__load-count');
        if (countEl) countEl.innerHTML = 'Showing <strong>' + shown + '</strong> of <strong>' + total + '</strong> products';

        var showingEl = wrapper.querySelector('.z9-cg__showing');
        if (showingEl) showingEl.textContent = 'Showing ' + shown + ' of ' + total + ' products';

        if (!container.dataset.nextUrl) {
          btn.style.display = 'none';
        } else {
          btn.disabled = false;
          btn.innerHTML = origHTML;
        }

        if (window.z9QuickView && typeof window.z9QuickView.ingest === 'function') {
          window.z9QuickView.ingest(doc);
        }

        if (window.jdgm && typeof jdgm.customizeBadges === 'function') jdgm.customizeBadges();
      })
      .catch(function () {
        btn.disabled = false;
        btn.innerHTML = origHTML;
      });
  }

  
  function toggleSidebar(open) {
    var sidebar = wrapper.querySelector('.z9-cg__sidebar');
    var overlay = wrapper.querySelector('.z9-cg__sidebar-overlay');
    if (!sidebar) return;
    if (open) {
      sidebar.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    } else {
      sidebar.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  }

  function toggleGroup(btn) {
    var group = btn.closest('.z9-cg__filter-group');
    if (!group) return;
    var open = group.dataset.open !== 'false';
    group.dataset.open = open ? 'false' : 'true';
  }

  function setColumns(cols) {
    currentCols = cols;
    var grid = wrapper.querySelector('.z9-cg__grid');
    if (grid) grid.dataset.columns = cols;
    var btns = wrapper.querySelectorAll('.z9-cg__grid-toggle-btn');
    for (var i = 0; i < btns.length; i++) {
      btns[i].classList.toggle('is-active', parseInt(btns[i].dataset.cols, 10) === cols);
    }
  }

  
  function addFromCard(btn) {
    var vid = btn.dataset.variantId;
    if (!vid || btn.disabled) return;
    btn.disabled = true;
    var origSvg = btn.innerHTML;
    var ss = btn.dataset.splitText || '';
    var props = ss ? { 'Split Shipping': ss } : null;
    addToCart(vid, props, function (ok) {
      if (ok) {
        btn.classList.add('z9-pc__add-btn--added');
        btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M20 6L9 17l-5-5"/></svg>';
        setTimeout(function () { btn.classList.remove('z9-pc__add-btn--added'); btn.innerHTML = origSvg; btn.disabled = false; }, 2000);
      } else { btn.disabled = false; }
    });
  }

  
  function addToCart(variantId, properties, cb) {
    var cartEl = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var body = { id: parseInt(variantId, 10), quantity: 1 };
    if (properties) body.properties = properties;
    if (cartEl && typeof cartEl.getSectionsToRender === 'function') {
      body.sections = cartEl.getSectionsToRender().map(function (s) { return s.id; }).join(',');
      body.sections_url = window.location.pathname;
      cartEl.setActiveElement(document.activeElement);
    }
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
      .then(function (resp) {
        if (resp.status) throw new Error();
        cb(true);
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'z9-collection', productVariantId: variantId, cartData: resp });
        }
        if (cartEl && typeof cartEl.renderContents === 'function') {
          cartEl.renderContents(resp);
          if (cartEl.classList.contains('is-empty')) cartEl.classList.remove('is-empty');
        } else {
          window.location = (window.routes && window.routes.cart_url) || '/cart';
        }
      })
      .catch(function () { cb(false); });
  }

  
  function enc(s) { return encodeURIComponent(s); }
})();
